import { Controller } from '@hotwired/stimulus'

// UrlUpdaterController
//
// Simple controller that updates the browser URL when connected to the DOM.
// Used to push a new URL to history after Turbo Stream updates without page navigation.
//
// Usage:
//   <div data-controller="url-updater" data-url-updater-url-value="/new/path">
//
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.hasUrlValue && this.urlValue) {
      history.pushState({ turbo: true }, '', this.urlValue)
    }
  }
}
